import { useEffect } from "react";
import { sanitizeText } from "../utils/complianceFilter";

/**
 * JACK ROYALS – ULTRA COMPLIANCE FILTER
 * Uses the shared sanitizeText utility (single source of truth)
 * to replace gambling terms across the entire DOM.
 * Runs on mount and observes all future DOM changes.
 */

let observer = null;
let isProcessing = false;

function sanitizeDOM() {
  if (isProcessing) return;
  isProcessing = true;

  // Pause observer to avoid infinite loop
  if (observer) observer.disconnect();

  const walker = document.createTreeWalker(
    document.body,
    NodeFilter.SHOW_TEXT,
    null,
    false
  );
  let node;
  while ((node = walker.nextNode())) {
    const parent = node.parentElement;
    if (parent && ["SCRIPT", "STYLE", "INPUT", "TEXTAREA", "NOSCRIPT"].includes(parent.tagName)) {
      continue;
    }
    // Skip elements marked as game names (should not be sanitized)
    if (parent && parent.closest("[data-no-sanitize]")) {
      continue;
    }
    const sanitized = sanitizeText(node.textContent);
    if (sanitized !== node.textContent) {
      node.textContent = sanitized;
    }
  }

  // Resume observer
  if (observer) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
  isProcessing = false;
}

export default function ComplianceFilter() {
  useEffect(() => {
    sanitizeDOM();

    observer = new MutationObserver(() => {
      sanitizeDOM();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    };
  }, []);

  return null;
}
